import {setSimulations} from "@/redux/slices/commonSlices/viewTabsSlice";

import {useEffect} from "react";

import {useReportOptions} from "@hooks/Report";
import {useViewTabs} from "@hooks/ViewTabs";
import {Footer} from "@layouts/main/Footer";
import {Header} from "@layouts/main/Header";
import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {CallPage} from "@pages/common/CallPage";
import {LibraryPage} from "@pages/common/LibraryPage";
import {ProductPage} from "@pages/common/ProductPage";
import {ReportPopup} from "@popups/requestPopups/ReportPopup";
import {ControlButton} from "@ui/buttons/ControlButton";
import {SwitchButton} from "@ui/buttons/SwitchButton";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {Route, Routes, useNavigate} from "react-router-dom";

import styles from "./styles.module.scss";

export const Simulations = () => {
  const {SIMULATIONS_REPORT_OPTIONS} = useReportOptions();
  const {SIMULATIONS_VIEW_TABS} = useViewTabs();
  const {simulations} = useSelector((state) => state.common.viewTabs);

  const {t} = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {openPopup} = usePopup();

  const handleOpenPopup = () => {
    openPopup(<ReportPopup options={SIMULATIONS_REPORT_OPTIONS} />);
  };

  const handleClickTab = (item) => {
    navigate(item.link);
    dispatch(setSimulations(item.value));
  };

  const handleTabChange = (value) => {
    const item = SIMULATIONS_VIEW_TABS.find((tab) => tab.value === value);
    if (item) handleClickTab(item);
  };

  useEffect(() => {
    navigate(simulations);
  }, []);

  return (
    <div className={styles.simulations}>
      <Header />

      <div className={"container-big"}>
        <div className={styles.simulationsHeader}>
          <SwitchButton
            value={simulations}
            onChange={handleTabChange}
            switchList={SIMULATIONS_VIEW_TABS}
            onClickTab={(item) => handleClickTab(item)}
            width={980}
            height={64}
            fontSize={28}
          />

          <ControlButton
            color={"var(--black)"}
            txt={t("button.report")}
            iconId={"report"}
            onClick={handleOpenPopup}
          />
        </div>
      </div>

      <Routes>
        <Route
          path={"call/*"}
          element={<CallPage />}
        />
        <Route
          path={"product/*"}
          element={<ProductPage />}
        />
        <Route
          path={"videos/*"}
          element={<LibraryPage />}
        />
      </Routes>

      <Footer />
    </div>
  );
};
